import {prop} from "ramda";
import {saveSlugsFromRels} from "../../features/stories/interceptors";
import API from "..";

const getWidgetByName = (name, payload) =>
  API.News.getWidgetByName({name, payload})
    .then(prop("data"))
    .then(saveSlugsFromRels);

export default getWidgetByName;
